<script setup lang="ts">
import type { Props } from './types';

defineProps<Props>();
</script>

<template>
	<div
		:class="{
			'top-tabs': true,
		}"
	>
		<!-- @slot Кнопки вкладок, ожидает передачу компонентов TabTitle -->
		<slot name="buttons"></slot>

		<div v-if="$slots.header" class="top-tabs_header">
			<!-- @slot Слот с проивзольным содержимым, которое будет добавлено справа от вкладок -->
			<slot name="header"></slot>
		</div>

		<div class="top-tabs_contents">
			<!-- @slot Контент вкладок, ожидает передачу компонентов TabContent -->
			<slot name="contents"></slot>
		</div>
	</div>
</template>

<style>
.top-tabs {
	background: var(--color-layout-front-1);
	border-radius: 8px;
	border: 1px solid var(--color-line-2-opacity);
	padding: 0;
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
}

.top-tabs_header {
	padding: 6px;
	margin-left: auto;
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}

/* Содержимое вкладок */
.top-tabs_contents {
	border-top: 1px solid var(--color-line-2-opacity);
	width: 100%;
	margin-top: -1px;
}

/* Состояние открытости вкладок */
.top-tabs_tabInput:checked:nth-child(1) ~ .top-tabs_contents > .top-tabs_content:nth-child(1),
.top-tabs_tabInput:checked:nth-child(3) ~ .top-tabs_contents > .top-tabs_content:nth-child(2),
.top-tabs_tabInput:checked:nth-child(5) ~ .top-tabs_contents > .top-tabs_content:nth-child(3),
.top-tabs_tabInput:checked:nth-child(7) ~ .top-tabs_contents > .top-tabs_content:nth-child(4),
.top-tabs_tabInput:checked:nth-child(9) ~ .top-tabs_contents > .top-tabs_content:nth-child(5),
.top-tabs_tabInput:checked:nth-child(11) ~ .top-tabs_contents > .top-tabs_content:nth-child(6) {
	display: block;
}
</style>
